var utils = require('util');

var BuilderApi = module.exports = {
    createUpdatePartObject: function(newPartId, category, configuredCaseId) {
        if(newPartId === "") {
            newPartId = null;
        }


        return {
            CaseId: configuredCaseId,
            PartData:[{
                NewPartId: newPartId,
                ItemType: 'SELECTION_PART_' + this.parseCategory(category)
            }],
            OptionData: []
        };
    },

    createUpdateOptionObject: function(configuredCaseId, option, value) {
        return {
            CaseId: configuredCaseId,
            OptionData: [{
                ItemType: 'SELECTION_OPTION_' + option,
                Value: value
            }],
            PartData: []
        }
    },

    createUpdateDimesionObject: function(value, dimension, configuredCaseId, useHeightUnits) {
        var object = {
            CaseId: parseInt(configuredCaseId),
            PartData: [],
            OptionData:[]
        };

        if(dimension === 'length' || dimension === 'width') {
            object['WidthMillimeters'] = value;
        }else if (dimension === 'depth') {
            object['LengthMillimeters'] = value;
        }else if(dimension === 'height') {
            if(useHeightUnits) {
                value = value / 45;
                object['HeightHeightUnits'] = value;
            }else{
                object['HeightMillimeters'] = value;
            }
        }else if(dimension === 'height_unit') {
            object['HeightHeightUnits'] = value;
        }

        return object;
    },
    createUpdateKeyboardObject: function(keyboardId, keyboard, configuredCaseId) {
        keyboardId = keyboardId || -1;
        keyboard = keyboard || 'None';

        if(keyboardId !== -1) {
            keyboard = null;
        }

        var object = {
            CaseId: parseInt(configuredCaseId),
            PartData:[],
            OptionData: [],
            KeyboardId: keyboardId,
            KeyboardBrandAndModel: keyboard
        };

        return object;
    },
    createUpdateKeysObject: function(amountOfKeys, configuredCaseId) {
        var object = {
            CaseId: configuredCaseId,
            PartData: [],
            OptionData:[],
            SizeKeyCount: amountOfKeys
        };

        return object;
    },
    isCaseIdSet: function(object) {
        return 'CaseId' in object && object['CaseId'];
    },
    parseCategory: function(category) {
        if(category === 'STAND') {
            return 'WHEEL';
        }else if(category === 'ROLL_BOARD') {
            return 'WHEEL';
        }else if(category === 'TROLLEY') {
            return 'WHEEL';
        }else if(category === 'ACCESSORY_PULLOUT_HANDLE'){
            return 'WHEEL';
        }

        return category;
    }


};


// WEBPACK FOOTER //
// ./node_modules/@thomann/caseconfigurator/lib/Models/BuilderApi.js